import { memo } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { FaqManagementSection } from './FaqManagementSection'
import { KnowledgeBaseSection } from './KnowledgeBaseSection'

interface FaqTabProps {
  openNextTab: () => void
  mentorId: string
  isReadyStatus: boolean
}

export interface Faq {
  question: string
  answer: string
  id?: string
  isNew?: boolean
}

const FaqTab: React.FC<FaqTabProps> = memo(
  ({ openNextTab, mentorId, isReadyStatus }) => {
    const navigate = useNavigate()

    const goToFaq = () => {
      navigate('/generate-twin/knowledge/faq')
    }

    return (
      <Routes>
        <Route
          path="/files"
          element={
            <KnowledgeBaseSection
              goNext={goToFaq}
              mentorId={mentorId}
              isReadyStatus={isReadyStatus}
            />
          }
        />
        <Route
          path="/faq"
          element={
            <FaqManagementSection
              openNextTab={openNextTab}
              isReadyStatus={isReadyStatus}
              mentorId={mentorId}
            />
          }
        />
      </Routes>
    )
  },
)

export { FaqTab }
